const Ajv = require('ajv')
const ajv = new Ajv()

export const isSchemaValid = (schema, data) => {
  const validator = ajv.compile(schema)
  const isValid = validator(data)

  if (!isValid) {
    validator.errors.map(error =>
      console.log('Validator error:', error.instancePath, error.message),
    )
  }

  return isValid
}
